// Senior-themed card surface. Larger padding, bigger title, optional
// secondary body text. Used as the primary content container on every
// page so the visual rhythm stays consistent.

import { BlockStack, Card, Text } from '@shopify/polaris';
import type { ReactNode } from 'react';

interface SeniorCardProps {
  title?: string;
  body?: string;
  children?: ReactNode;
  'data-testid'?: string;
}

export function SeniorCard({ title, body, children, ...rest }: SeniorCardProps) {
  return (
    <div {...rest}>
      <Card>
        <BlockStack gap="400">
          {title ? (
            <Text as="h2" variant="headingMd">
              {title}
            </Text>
          ) : null}
          {body ? (
            <Text as="p" variant="bodyLg">
              {body}
            </Text>
          ) : null}
          {children}
        </BlockStack>
      </Card>
    </div>
  );
}
